export default "__VITE_ASSET__5kDNrCWF__"